import { render, staticRenderFns } from "./ManuInfoCoqun.vue?vue&type=template&id=605a265e&scoped=true&"
import script from "./ManuInfoCoqun.vue?vue&type=script&lang=js&"
export * from "./ManuInfoCoqun.vue?vue&type=script&lang=js&"
import style0 from "./ManuInfoCoqun.vue?vue&type=style&index=0&id=605a265e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605a265e",
  null
  
)

export default component.exports